export function removeDocumentReferenceFromString(text: string) {
  const regex = /\[doc[1-9]\]/g;
  return text.replace(regex, "");
}
